import React from 'react'

import Loader from '../../../../Mantine/Loader'
import CheckboxFilter from '../Checkbox'
import DatePickerFilter from '../DatePicker'
import Input from '../Input'
import InputRadioFilter from '../InputRadio'
import RadioFilter from '../Radio'
import SelectFilter from '../Select'

import * as S from './styles'

const FILTROS_LABEL = {
  OPERADORA: 'Operadoras',
  REDE: 'Rede',
  STATUS: 'Status',
  TECNOLOGIA: 'Tecnologia',
  TRAFEGO: 'Tráfego ',
  CONEXOES: 'Conexões',
  ULTIMO_EVENTO: 'Último evento',
  PLANO_TIPO: 'Plano tipo',
  ENVIO_SMS: 'Envio SMS',
  TIPO_SIMCARD: 'Tipo de SIM Card',
  PACOTE_EXTRA: 'Pacote extra',
  PACOTES: 'Pacotes',
  VALOR: 'Valor',
  DIAS_UTILIZADOS: 'Dias utilizados',
  AQUISICAO: 'Aquisição',
  ATIVACAO: 'Ativação',
  SERVICOS_ADICIONAIS: 'Serviços adicionais',
  CONSUMO: 'Consumo',
  SALDO: 'Saldo',
  ICCID_INTERVALO: 'ICCID por intervalo',
  MARCA_MODELO: 'Marca e modelo',
  GRUPO: 'Grupo',
  STATUS_CONTRATO: 'Status do contrato',
  CLIENTE_FINAL: 'Cliente final'
}

const CAMPOS_FILTRO = {
  checkbox: ['OPERADORA', 'REDE'],
  radio: [
    'STATUS',
    'TECNOLOGIA',
    'TRAFEGO',
    'PLANO_TIPO',
    'ENVIO_SMS',
    'TIPO_SIMCARD',
    'PACOTE_EXTRA'
  ],
  inputRadio: ['CONEXOES', 'PACOTES', 'CONSUMO'],
  input: [
    'VALOR',
    'DIAS_UTILIZADOS',
    'SALDO',
    'ICCID_INTERVALO',
    'CLIENTE_FINAL'
  ],
  datePicker: ['ULTIMO_EVENTO', 'AQUISICAO', 'ATIVACAO'],
  select: ['SERVICOS_ADICIONAIS', 'GRUPO', 'STATUS_CONTRATO'],
  twoSelect: ['MARCA_MODELO']
}

const FILTROS_LOADER_EXTERNO = ['OPERADORA', 'REDE', 'TIPO_SIMCARD']

const FILTROS_LOADER_DO_COMPONENTE = [
  'SERVICOS_ADICIONAIS',
  'STATUS_CONTRATO',
  'GRUPO',
  'MARCA_MODELO'
]

const COMPONENTS = {
  checkbox: ({ nome, localFilters, setLocalFilters, opcoes }) => (
    <CheckboxFilter
      nome={nome}
      localFilters={localFilters}
      setLocalFilters={setLocalFilters}
      opcoes={opcoes}
    />
  ),
  radio: ({ nome, localFilters, setLocalFilters, opcoes }) => (
    <RadioFilter
      nome={nome}
      localFilters={localFilters}
      setLocalFilters={setLocalFilters}
      opcoes={opcoes}
    />
  ),
  inputRadio: ({ nome, localFilters, setLocalFilters, setErroNosDados }) => (
    <InputRadioFilter
      nome={nome}
      localFilters={localFilters}
      setLocalFilters={setLocalFilters}
      setErroNosDados={setErroNosDados}
    />
  ),
  input: ({ nome, localFilters, setLocalFilters, setErroNosDados }) => (
    <Input
      comRadio={nome === 'CLIENTE_FINAL'}
      nome={nome}
      localFilters={localFilters}
      setLocalFilters={setLocalFilters}
      setErroNosDados={setErroNosDados}
    />
  ),
  datePicker: ({ nome, localFilters, setLocalFilters }) => (
    <DatePickerFilter
      nome={nome}
      localFilters={localFilters}
      setLocalFilters={setLocalFilters}
    />
  ),
  select: ({ nome, localFilters, setLocalFilters, opcoes, isLoading }) => (
    <SelectFilter
      localFilters={localFilters}
      setLocalFilters={setLocalFilters}
      nome={nome}
      opcoes={opcoes}
      isLoading={isLoading}
    />
  ),

  twoSelect: ({ nome, localFilters, setLocalFilters, opcoes, isLoading }) => (
    <SelectFilter
      localFilters={localFilters}
      setLocalFilters={setLocalFilters}
      nome={nome}
      opcoes={opcoes}
      isTwoSelect
      isLoading={isLoading}
    />
  )
}

export default function Filtros({
  nome,
  localFilters,
  setLocalFilters,
  opcoes,
  setErroNosDados,
  loadingStates = {}
}) {
  const tipoCampo = Object.entries(CAMPOS_FILTRO).find(([, valores]) =>
    valores.includes(nome)
  )?.[0]

  const isLoadingExterno = FILTROS_LOADER_EXTERNO.includes(nome)
    ? loadingStates[nome]
    : false

  const isLoadingInterno = FILTROS_LOADER_DO_COMPONENTE.includes(nome)
    ? loadingStates[nome]
    : false

  const renderCampo =
    tipoCampo && COMPONENTS[tipoCampo]
      ? COMPONENTS[tipoCampo]({
          nome,
          localFilters,
          setLocalFilters,
          opcoes,
          setErroNosDados,
          isLoading: isLoadingInterno
        })
      : null

  return (
    <S.Filtro>
      <S.Label>{FILTROS_LABEL[nome]}</S.Label>
      {isLoadingExterno ? (
        <S.LoadingWrapper>
          <Loader />
          <span>Carregando...</span>
        </S.LoadingWrapper>
      ) : (
        renderCampo
      )}
    </S.Filtro>
  )
}
